import repositoryFactory from '@/helpers/api/apiFactory';
const api = repositoryFactory('calendar');

const state = {
    items: null,

    pickerOptions: null,
    showDate: false,
    activeDate: null, 
    showBreadcrumbs: false,
    show: false,
    doesListItemsHaveScroll: false,
};

const mutations = {
    setState: (state, {key, value}) => {
        state[key] = value;
    }
};

const actions = {
    async get({state, commit}, params) {
        const response = await api.get(params);

        commit('setState', {
            key: 'items',
            value: response.data.data || []
        });
    },
};

const getters = {
    items: state => state.items,
    pickerOptions: state => state.pickerOptions,
    showDate: state => state.showDate, 
    activeDate: state => state.activeDate,
    showBreadcrumbs: state => state.showBreadcrumbs,
    show: state => state.show,
    doesListItemsHaveScroll: state => state.doesListItemsHaveScroll,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};